import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { filter, map, Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonMode, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { TranslatedBenefitRow } from '@fcom/dapi/api/models/translated-benefit-row';
import { UpsellPromotion } from '@fcom/booking/modules/ticket-selection/interfaces/cabin-class-selection-fare-family.interface';

import { shouldDisplayBenefit } from '../../../utils/benefit.utils';

@Component({
  selector: 'fin-upsell-promotion',
  templateUrl: './upsell-promotion.component.html',
  styleUrls: ['./upsell-promotion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpsellPromotionComponent implements OnInit {
  @Input() upsellOffer$: Observable<UpsellPromotion>;

  @Output()
  confirmUpsell: EventEmitter<void> = new EventEmitter();

  public readonly ButtonTheme = ButtonTheme;
  public readonly SvgLibraryIcon = SvgLibraryIcon;
  public readonly IconPosition = IconPosition;
  public readonly ButtonMode = ButtonMode;

  currentBenefits$: Observable<TranslatedBenefitRow[]>;
  newBenefits$: Observable<TranslatedBenefitRow[]>;

  ngOnInit(): void {
    this.currentBenefits$ = this.upsellOffer$.pipe(
      filter(Boolean),
      map((offer) => offer.currentOffer.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)))
    );

    this.newBenefits$ = this.upsellOffer$.pipe(
      filter(Boolean),
      map((offer) => offer.upsellOffer.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)))
    );
  }
}
